import React from 'react';
import {
  MapContainer, TileLayer, Marker, Popup,
} from 'react-leaflet';
import PropTypes from 'prop-types';
import { getMapboxKey } from 'urlConfig';
/* import FavoriteHeart from 'components/Favorite'; */
import AddRemoveCandidateButton from '../../pages/Experience/src/components/buttons/add-remove-candidate';
import RequestVisitButton from '../../pages/Experience/src/components/buttons/request-visit';
import happyMapIcon from './mapIcon';
import './styles.css';
import precio from '../../assets_vacanted/precio.png';
import idioma from '../../assets_vacanted/idiomas.png';
import religion from '../../assets_vacanted/religion.png';
import { getAgesMessageToShow } from '../../utils/schools/schoolFunctions';
import countryService from '../../services/countryService';

import specificStyles from './mapView.module.css';

const MapView = ({
  latitude, longitude, heightSize, widthSize, schools,
}) => {
  /* eslint no-underscore-dangle: 0 */
  const handleClosePopup = (event) => {
    event.target._popup._closeButton.addEventListener('click', (ev) => {
      ev.preventDefault();
    });
  };

  return (
    <div id="page-map" className="vacanted__mapView">
      <MapContainer
        center={[latitude, longitude]}
        zoom={14}
        style={{ maxWidth: widthSize, height: heightSize }}
      >
        <TileLayer url={`https://api.mapbox.com/styles/v1/mapbox/light-v10/tiles/256/{z}/{x}/{y}@2x?access_token=${getMapboxKey()}`} />
        {schools.map((school) => (
          <Marker
            icon={happyMapIcon}
            position={[school.latitude, school.longitude]}
            key={school.id}
            className="map-popup"
            eventHandlers={{ click: (e) => handleClosePopup(e) }}
          >
            <Popup closeButton maxHeight={250} width={780} className="map-popup">
              <h4 className={`${specificStyles['popup-title']} ${specificStyles['limit-text']}`}>
                <a
                  href={`/school/${school.id}`}
                  target="_blank"
                  rel="noreferrer noopener"
                  className={specificStyles.school__name}
                >
                  {school.name}
                </a>
              </h4>
              <div className="popup-address">
                <p className={specificStyles['limit-text']}>
                  {`${school.address}, ${school.neighborhood.name}`}
                </p>
                {/* <p className="school-public">{school.city.name}</p> */}
              </div>
              <div className="popup-info">
                <h4 className="school-public">
                  {`${school.public.name} de Educación ${getAgesMessageToShow(school.schedules, countryService.getCurrentCountryId())}`}
                </h4>
                <div className="item">
                  <p className="info-icon">
                    <img src={precio} alt="Precio" className="icons-item" />
                    {school.cost.name}
                  </p>
                  {school.religious ? (
                    <p className="info-icon">
                      <img src={religion} alt="Precio" className="icons-item" />
                      Religioso
                    </p>
                  ) : (
                    <p className="info-icon">
                      <img src={religion} alt="Precio" className="icons-item" />
                      Laico
                    </p>
                  )}
                  {school.languages.length > 1 ? (
                    <p className="info-icon">
                      <img src={idioma} alt="Idioma" className="icons-item" />
                      {school.languages.length === 2 ? 'Bilingüe' : 'Trilingüe'}
                    </p>
                  ) : (
                    <p className="info-icon">
                      <img src={idioma} alt="Idioma" className="icons-item" />
                      {school.language1.name}
                    </p>
                  )}
                </div>
              </div>
              <div className="line" />

              <div className="popup-buttons">
                {/* <FavoriteHeart school={school} from="mapView" /> */}
                {/* <button
                  type="button"
                  onClick={() => handleOpenContactModal(school.id)}
                  disabled={
                    school.contact_disabled || school.public_id === 2 || school.public_id === 7
                  }
                >
                  Contactar
                </button> */}
                <RequestVisitButton
                  schoolId={school.id}
                  disabled={school.contact_disabled || school.public?.is_public}
                />
                <AddRemoveCandidateButton
                  schoolId={school.id}
                />
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
};

MapView.propTypes = {
  latitude: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  longitude: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  widthSize: PropTypes.string.isRequired,
  heightSize: PropTypes.string.isRequired,
  schools: PropTypes.instanceOf(Array).isRequired,
};

export default MapView;
